var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "new-hsb-subscription-view" } },
    [
      _vm.annualPaidProduct && _vm.canHavePaidSubscription(_vm.accountData)
        ? _c(
            "b-row",
            {
              staticClass: "mb-0 pb-0",
              attrs: { "align-h": "center", "no-gutters": "" }
            },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "subs-info-card mb-0 sub-card",
                      class: _vm.isPaidSelected ? "selected" : "",
                      attrs: {
                        "body-class": "subs-info-card-body",
                        "data-test-hook": "new-hsb-subscription-modal-paid-card"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "plan-header",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-paid-subscription-header"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.annualPaidProduct.name) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1868828425
                      )
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("CadenceSelectionTabs", {
                                attrs: {
                                  "annual-paid-product": _vm.annualPaidProduct,
                                  "monthly-paid-product":
                                    _vm.monthlyPaidProduct,
                                  "selected-product": _vm.activePaidSub
                                },
                                on: {
                                  setSelectedProduct: _vm.setSelectedProduct
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "text-center mt-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "subscription-radio",
                                    pill: "",
                                    pressed:
                                      _vm.selectedProduct && _vm.isPaidSelected,
                                    "data-test-hook":
                                      "new-hsb-subscription-modal-select-yearly-button"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSelectedProduct(
                                        _vm.activePaidSub ||
                                          _vm.annualPaidProduct
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "sub-radio-dot align-middle"
                                    },
                                    [
                                      _c("i", {
                                        class:
                                          _vm.selectedProduct &&
                                          _vm.isPaidSelected
                                            ? "fa-solid fa-circle"
                                            : "fa-regular fa-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatCurrency")(
                                          _vm.isPaidSelected
                                            ? _vm.selectedProduct.cost
                                            : _vm.activePaidSub.cost
                                        )
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-bottom sub-premium-radio-duration"
                                    },
                                    [_vm._v("/" + _vm._s(_vm.durationLabel))]
                                  ),
                                  _vm.activePaidSub &&
                                  _vm.activePaidSub.durationInMonths === 12
                                    ? _c(
                                        "span",
                                        { staticClass: "ml-2 savings-label" },
                                        [
                                          _vm._v(
                                            "- " +
                                              _vm._s(_vm.$t("xSavePercent"))
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "subscriptionCardText" },
                        [
                          _vm.annualPaidProduct &&
                          _vm.annualPaidProduct.description
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-premium-monitoring-max-products-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.annualPaidProduct.description
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "b-row",
                            { staticClass: "mt-2" },
                            [
                              _c("b-col", [
                                _c(
                                  "strong",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-included-features-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("xAdditionalPremiumFeatures")
                                      )
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.genStatusDesc",
                                  modifiers: { genStatusDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-circle-check",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-gen-status-icon"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-left",
                                  attrs: {
                                    "data-test-hook":
                                      "new-hsb-subscription-modal-paid-gen-status-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xGeneratorStatus")) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "genStatusDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-paid-gen-status-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("xGenStatusDesc")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.manualsDesc",
                                  modifiers: { manualsDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-book",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-manuals-icon"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-left",
                                  attrs: {
                                    "data-test-hook":
                                      "new-hsb-subscription-modal-paid-manuals-text"
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("xManuals")) + " ")]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "manualsDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-paid-manuals-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("xManualsDesc")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.statusHistoryDesc",
                                  modifiers: { statusHistoryDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-regular fa-clock-rotate-left",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-status-history-icon"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-left",
                                  attrs: {
                                    "data-test-hook":
                                      "new-hsb-subscription-modal-paid-status-history-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("xStatusHistory")) + " "
                                  )
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "statusHistoryDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-paid-status-history-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("xStatusHistoryDesc")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.monthlySummaryEmailDesc",
                                  modifiers: { monthlySummaryEmailDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-regular fa-envelope-open-text",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-monthly-email-icon"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-left",
                                  attrs: {
                                    "data-test-hook":
                                      "new-hsb-subscription-modal-paid-monthly-email-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xMonthlyEmailSummary")) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "monthlySummaryEmailDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-paid-monthly-email-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xMonthlySummaryEmailDesc")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.maintenanceDetailsDesc",
                                  modifiers: { maintenanceDetailsDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-toolbox",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-maintenance-icon"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-left",
                                  attrs: {
                                    "data-test-hook":
                                      "new-hsb-subscription-modal-paid-maintenance-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xMaintenanceTracking")) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "maintenanceDetailsDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-paid-maintenance-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xMaintenanceTrackingDesc")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.exerciseOnDemandDesc",
                                  modifiers: { exerciseOnDemandDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "colorOrange fa-regular fa-bolt",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-demand-exercise-icon"
                                    }
                                  })
                                ]
                              ),
                              _c("b-col", { staticClass: "float-left" }, [
                                _c(
                                  "strong",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-demand-exercise-text"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("xExerciseOnDemand")))]
                                )
                              ]),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "exerciseOnDemandDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-paid-demand-exercise-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xExerciseOnDemandDesc")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.realTimeAlertsDesc",
                                  modifiers: { realTimeAlertsDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "colorOrange fa-regular fa-bell",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-alerts-icon"
                                    }
                                  })
                                ]
                              ),
                              _c("b-col", { staticClass: "float-left" }, [
                                _c(
                                  "strong",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-alerts-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("xRealTimeAlerts")) + "*"
                                    )
                                  ]
                                )
                              ]),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "realTimeAlertsDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-paid-alerts-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xRealTimeAlertsDesc")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.exerciseTimeDesc",
                                  modifiers: { exerciseTimeDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "colorOrange fa-regular fa-clock",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-exercise-time-icon"
                                    }
                                  })
                                ]
                              ),
                              _c("b-col", { staticClass: "float-left" }, [
                                _c(
                                  "strong",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-paid-exercise-time-text"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("xExerciseSettings")))]
                                )
                              ]),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "exerciseTimeDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-paid-exercise-time-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("xExerciseTimeDesc")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.dismissWarningsDesc",
                                  modifiers: { dismissWarningsDesc: true }
                                }
                              ],
                              staticClass: "expandable-click-area",
                              attrs: { "align-v": "center" }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 text-center",
                                  attrs: { cols: "1" }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "colorOrange fa-regular fa-warning",
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-dismiss-warnings-icon"
                                    }
                                  })
                                ]
                              ),
                              _c("b-col", { staticClass: "float-left" }, [
                                _c(
                                  "strong",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "new-hsb-subscription-modal-dismiss-warnings-text"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("xDismissWarnings")))]
                                )
                              ]),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-closed",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-down"
                                  })
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "float-right when-open",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-angle-up"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            { attrs: { id: "dismissWarningsDesc" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-dismiss-warnings-desc"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xDismissWarningsDesc")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.freeProduct
                    ? _c(
                        "b-card",
                        {
                          staticClass: "subs-info-card sub-card",
                          class: !_vm.isPaidSelected ? "selected" : "",
                          attrs: {
                            "body-class": "subs-info-card-body",
                            "data-test-hook":
                              "new-hsb-subscription-modal-free-card"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "plan-header",
                                        attrs: {
                                          "data-test-hook":
                                            "new-hsb-free-subscription-header"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("xMobileLinkBasic")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            834007989
                          )
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "text-center mt-2 included-button" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "subscription-radio",
                                        pill: "",
                                        pressed:
                                          _vm.selectedProduct &&
                                          _vm.selectedProduct.productId ==
                                            _vm.freeProduct.productId,
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-free-select-button"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setSelectedProduct(
                                            _vm.freeProduct
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "sub-radio-dot align-middle"
                                        },
                                        [
                                          _c("i", {
                                            class:
                                              _vm.selectedProduct &&
                                              _vm.selectedProduct.productId ==
                                                _vm.freeProduct.productId
                                                ? "fa-solid fa-circle"
                                                : "fa-regular fa-circle"
                                          })
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "sub-free-radio-text align-middle"
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("xIncluded"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "subscriptionCardText" },
                            [
                              _c(
                                "b-row",
                                { staticClass: "mb-2" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-basic-monitoring-max-products-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("xBasicDescription")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c("b-col", [
                                    _c(
                                      "strong",
                                      {
                                        attrs: {
                                          "data-test-hook":
                                            "new-hsb-subscription-modal-free-included-features-text"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("xIncludedBasicFeatures")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.genStatusDescBasic",
                                      modifiers: { genStatusDescBasic: true }
                                    }
                                  ],
                                  staticClass: "expandable-click-area",
                                  attrs: { "align-v": "center" }
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pr-0 text-center",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-check",
                                        attrs: {
                                          "data-test-hook":
                                            "new-hsb-subscription-modal-basic-gen-status-icon"
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-left",
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-basic-gen-status-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("xGeneratorStatus")) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-closed",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-down"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-open",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-up"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-collapse",
                                { attrs: { id: "genStatusDescBasic" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            "data-test-hook":
                                              "new-hsb-subscription-modal-basic-gen-status-desc"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("xGenStatusDesc")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.manualsDescBasic",
                                      modifiers: { manualsDescBasic: true }
                                    }
                                  ],
                                  staticClass: "expandable-click-area",
                                  attrs: { "align-v": "center" }
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pr-0 text-center",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-regular fa-book",
                                        attrs: {
                                          "data-test-hook":
                                            "new-hsb-subscription-modal-basic-manuals-icon"
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-left",
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-basic-manuals-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("xManuals")) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-closed",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-down"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-open",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-up"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-collapse",
                                { attrs: { id: "manualsDescBasic" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            "data-test-hook":
                                              "new-hsb-subscription-modal-basic-manuals-desc"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("xManualsDesc")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName:
                                        "v-b-toggle.statusHistoryDescBasic",
                                      modifiers: {
                                        statusHistoryDescBasic: true
                                      }
                                    }
                                  ],
                                  staticClass: "expandable-click-area",
                                  attrs: { "align-v": "center" }
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pr-0 text-center",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-clock-rotate-left",
                                        attrs: {
                                          "data-test-hook":
                                            "new-hsb-subscription-modal-basic-status-history-icon"
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-left",
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-basic-status-history-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("xStatusHistory")) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-closed",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-down"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-open",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-up"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-collapse",
                                { attrs: { id: "statusHistoryDescBasic" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            "data-test-hook":
                                              "new-hsb-subscription-modal-basic-status-history-desc"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("xStatusHistoryDesc")
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName:
                                        "v-b-toggle.monthlySummaryEmailDescBasic",
                                      modifiers: {
                                        monthlySummaryEmailDescBasic: true
                                      }
                                    }
                                  ],
                                  staticClass: "expandable-click-area",
                                  attrs: { "align-v": "center" }
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pr-0 text-center",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-envelope-open-text",
                                        attrs: {
                                          "data-test-hook":
                                            "new-hsb-subscription-modal-basic-monthly-email-icon"
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-left",
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-basic-monthly-email-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xMonthlySummaryEmail")
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-closed",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-down"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-open",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-up"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-collapse",
                                {
                                  attrs: { id: "monthlySummaryEmailDescBasic" }
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            "data-test-hook":
                                              "new-hsb-subscription-modal-basic-monthly-email-desc"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "xMonthlySummaryEmailDesc"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName:
                                        "v-b-toggle.maintenanceDetailsDescBasic",
                                      modifiers: {
                                        maintenanceDetailsDescBasic: true
                                      }
                                    }
                                  ],
                                  staticClass: "expandable-click-area",
                                  attrs: { "align-v": "center" }
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pr-0 text-center",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-regular fa-toolbox",
                                        attrs: {
                                          "data-test-hook":
                                            "new-hsb-subscription-modal-basic-maintenance-icon"
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-left",
                                      attrs: {
                                        "data-test-hook":
                                          "new-hsb-subscription-modal-basic-maintenance-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xMaintenanceTracking")
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-closed",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-down"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "float-right when-open",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-angle-up"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-collapse",
                                {
                                  attrs: { id: "maintenanceDetailsDescBasic" }
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            "data-test-hook":
                                              "new-hsb-subscription-modal-basic-maintenance-desc"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "xMaintenanceTrackingDesc"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        { staticClass: "mt-3", attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            { staticClass: "float-left pl-2", attrs: { cols: "12" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "w-100",
                  attrs: {
                    variant: "warning",
                    disabled:
                      !_vm.selectedProduct || _vm.isCreatingPurchaseIntent,
                    "data-test-hook":
                      "new-hsb-subscription-modal-confirm-plan-button"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("openPayment")
                    }
                  }
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("xContinue")) + " "),
                  _vm.isCreatingPurchaseIntent
                    ? _c("b-spinner", { staticClass: "ml-2" })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showSelectSubError
        ? _c(
            "div",
            {
              staticClass: "alert alert--validation alert-danger",
              attrs: { show: _vm.showSelectSubError }
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("xFailedSetUpGeneratorSubscription")) + " "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }